// ============================
// Helpers: تحويل بين ArrayBuffer و Base64
// ============================
function bufferToBase64(buf) {
  return btoa(String.fromCharCode(...new Uint8Array(buf)));
}

function base64ToBuffer(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes.buffer;
}

// ============================
// توليد مفتاح AES من Password (PBKDF2)
// ============================
async function deriveKey(password, salt) {
  const baseKey = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(password),
    "PBKDF2",
    false,
    ["deriveKey"]
  );

  return crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt,
      iterations: 150000,
      hash: "SHA-256"
    },
    baseKey,
    { name: "AES-GCM", length: 256 },
    false,
    ["encrypt", "decrypt"]
  );
}

// ============================
// Encrypt Data
// ============================
export async function encryptData(data, password) {
  const salt = crypto.getRandomValues(new Uint8Array(16));
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const key = await deriveKey(password, salt);

  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    new TextEncoder().encode(JSON.stringify(data))
  );

  return { encrypted, salt, iv };
}

// ============================
// Decrypt Data
// ============================
export async function decryptData(payload, password) {
  const { encrypted, salt, iv } = payload;

  try {
    // اشتق المفتاح
    const key = await deriveKey(password, salt);

    // فك التشفير
    const decrypted = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      key,
      encrypted
    );

    // رجع الداتا + status boolean
    return { status: true, data: JSON.parse(new TextDecoder().decode(decrypted)) };
  } catch (err) {
    // لو أي حاجة غلط (باسورد غلط / corrupted data)
    return { status: false, data: null };
  }
}

// ============================
// Save to Cookie
// ============================
export function saveToCookie(name, obj) {
  const cookieValue = encodeURIComponent(JSON.stringify({
    encrypted: bufferToBase64(obj.encrypted),
    salt: bufferToBase64(obj.salt.buffer),
    iv: bufferToBase64(obj.iv.buffer)
  }));

  document.cookie = `${name}=${cookieValue}; path=/`;
}

export function loadFromCookie(name) {
  const match = document.cookie.split("; ").find(row => row.startsWith(name + "="));
  if (!match) return null;

  const cookieObj = JSON.parse(decodeURIComponent(match.split("=")[1]));

  return {
    encrypted: base64ToBuffer(cookieObj.encrypted),
    salt: new Uint8Array(base64ToBuffer(cookieObj.salt)),
    iv: new Uint8Array(base64ToBuffer(cookieObj.iv))
  };
}